import * as React from "react";
import { Layout } from "../../layout";
import { Routes, Route } from "react-router-dom";
import { LocationList } from "./list";
import { useAppSelector } from "../../store/hooks";
import { selectOrg } from "../../store/contextSlice";
import { LocationCreateInitializer } from "./create/initializer";
import { LocationDetailInitializer } from "./detailInitializer";

const LocationRoute: React.FC = () => {
  const org = useAppSelector(selectOrg);

  return (
    <Layout key={org}>
      <Routes>
        <Route index element={<LocationList />} />
        <Route path={`-create/*`} element={<LocationCreateInitializer />} />
        <Route path={`:location/*`} element={<LocationDetailInitializer />} />
      </Routes>
    </Layout>
  );
};

export default LocationRoute;
